import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

// Route pages call this on entry: an expired session goes back to sign-in
// (the check every legacy page did in created()).
export function useSessionGuard() {
  const store = useStore();
  const router = useRouter();
  if (store.state.expiryDate < Date.now()) {
    store.dispatch('setUser', null);
    store.dispatch('setIsAuthenticated', 0);
    router.push('/');
  }
}
